import React, { Component } from 'react';
import './App.css';
import { database, initializeApp } from "firebase";
import Config from './fire'

class App extends Component {
  state = {
    times: {}
  }
  componentWillMount() {
    initializeApp(Config);
  }
  componentDidMount() {
    database().ref("times").once('value', times => this.setState({ times: times.val() || {} },()=>
    this.intro.scrollTop = this.intro.scrollHeight+200))
    database().ref("times").on('value', times => this.setState({ times: times.val() || {} },()=>
    this.intro.scrollTop = this.intro.scrollHeight+200))
  }

  add = () => {
    database().ref(`times`).push(new Date().toLocaleString('nl-NL'));
    this.intro.scrollTop = this.intro.scrollHeight
  }

  minutesAgo = (index, list) => {
    const baseFormula = (this.Parse(index, list) - this.Parse(index - 1, list)) / 1000
    const diffMin = Math.floor(baseFormula / 60);
    const diffSec = baseFormula % 60;
    return <div style={{color:diffMin<4?'green':'red'}} >{diffMin + ":" + (diffSec < 10 ? ("0"+diffSec):diffSec)}</div>;
  }

  Parse = (index, list) => Date.parse(this.state.times[list[index]].replace("-3-", "-Mar-"))

  render() {
    const list = Object.keys(this.state.times);
    return (
      <div className="App">
        <header className="App-header">
          <h1 className="App-title">BabyTimer</h1>
          <button onClick={this.add}>add Time</button>
        </header>
        <div className='App-intro' ref={e=>this.intro = e}>
        {
          list.map(
            (e, i) => (
              <div key={e} style={{display:"flex"}}>
                {`${this.state.times[e]} ------ `} {i === 0 ? "" : this.minutesAgo(i, list)}
              </div>
            )
          )
        }
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js